
import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({  
  name: 'user',
  initialState: {
    id: '',
    fname: 'exemple',
    lname: 'exemple',
    avatar: '',
    phone: '',
    email: '',
    verif: 0,
    limit: 0,
    type: 0,
    isAuth: false,
  },
  reducers: {
    setUserInfo: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setUserInfo } = userSlice.actions;

export default userSlice.reducer;
